import api from "@/lib/api";

export const partyApi = {
  create: (mode, pack = "default") => api.post("/party/rooms", { mode, pack }).then((r) => r.data),
  listPacks: () => api.get("/party/packs").then((r) => r.data),
  createPack: (name, prompts) => api.post("/party/packs", { name, prompts }).then((r) => r.data),
  join: (code, name, avatar = "") => api.post(`/party/rooms/${code}/join`, { name, avatar }).then((r) => r.data),
  state: (code, { pid = "", hostToken = "" } = {}) =>
    api.get(`/party/rooms/${code}/state`, { params: { pid, host_token: hostToken } }).then((r) => r.data),
  start: (code, hostToken) => api.post(`/party/rooms/${code}/start`, { host_token: hostToken }).then((r) => r.data),
  next: (code, hostToken) => api.post(`/party/rooms/${code}/next`, { host_token: hostToken }).then((r) => r.data),
  end: (code, hostToken) => api.post(`/party/rooms/${code}/end`, { host_token: hostToken }).then((r) => r.data),
  answer: (code, pid, token, payload) => api.post(`/party/rooms/${code}/answer`, { pid, token, ...payload }).then((r) => r.data),
  vote: (code, pid, token, answerId) => api.post(`/party/rooms/${code}/vote`, { pid, token, answer_id: answerId }).then((r) => r.data),
};

export const saveHost = (code, t) => localStorage.setItem(`party_host_${code}`, t);
export const getHost = (code) => localStorage.getItem(`party_host_${code}`) || "";
export const savePlayer = (code, p) => localStorage.setItem(`party_player_${code}`, JSON.stringify(p));
export const getPlayer = (code) => {
  try { return JSON.parse(localStorage.getItem(`party_player_${code}`) || "null"); } catch { return null; }
};
